<template>
	<div>
		<template v-if="!disabled && !readonly">
			<van-field :required="formCreateInject.rule.validate.required" readonly :disabled="disabled"
				:label="formCreateInject.prop.title.title" :value="valuetext" placeholder="" @click="showPicker = true"
				input-align="right">
				<template #left-icon>
					<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
				</template>
			</van-field>
			<van-popup get-container="body" v-model="showPicker" round position="bottom">
				<van-picker value-key="label" show-toolbar :columns="selectoption" @cancel="showPicker = false"
					@confirm="onConfirm" :title="formCreateInject.prop.title.title" />
			</van-popup>
		</template>
		<template v-else>
			<van-field readonly :label="formCreateInject.prop.title.title"
				:value="valuetext" placeholder="" input-align="right" />

		</template>
	</div>
</template>

<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}
</style>
<script>
	import department from '@_system/components/formcomponents/common/select/department/select.vue'
	export default {
		extends: department,
		data() {
			return {
				ready: false,
				showPicker: false,
				options: [],
				columns: [],
				selectoption: [],
			}
		},
		created() {
			//console.log(this.options)
		},
		mounted() {
			let selectoption = []
			this.sourceData.forEach((item) => {
				selectoption.push({
					label: item.label,
					value: item.value
				})
			})
			this.selectoption = selectoption
		},
		watch: {
			options(v) {
				v.forEach((item) => {
					this.columns.push(item)
				})
			}
		},
		computed: {

		},

		methods: {
			onConfirm(value) {
				if (value) {
					let postvalue = ''
					if (Array.isArray(value)) {
						value.forEach((item, index) => {
							value[index] = this.labelTovalue(item)
						})
						postvalue = value
					} else {
						postvalue = value.value
					}
					this.change(postvalue)
				}
				this.showPicker = false
			},
		}
	}
</script>
